import { useRouteLoaderData } from 'react-router';

import type { RootLoaderData } from '@jane/bloom/types/schemas/bloom/rootLoader';
import { BloomError } from '@jane/bloom/utils/errors/bloomError';

/**
 * Shorthand to retrieve loader data from the root route, which should be a match for every route.
 * @see @jane/bloom/root
 */
export function useRootLoaderData(): RootLoaderData {
  const data = useRouteLoaderData<RootLoaderData>('root');
  if (!data) {
    throw new BloomError({ message: 'No root loader data found' });
  }

  return data;
}
